import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';

const anniversaryPlanKeys = {
  all: ['anniversaryPlan'],
  summary: (filters) => [...anniversaryPlanKeys.all, 'summary', filters],
  installments: (filters) => [...anniversaryPlanKeys.all, 'installments', filters],
  history: (filters) => [...anniversaryPlanKeys.all, 'history', filters],
};

export const useAnniversaryPlanSummary = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: anniversaryPlanKeys.summary(filters),
    queryFn: async () => {
      const response = await apiClient.get('anniversary-plan/summary', { params: filters });
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
};

export const useAnniversaryPlanInstallments = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: anniversaryPlanKeys.installments(filters),
    queryFn: async () => {
      const response = await apiClient.get('anniversary-plan/installments', { params: filters });
      return response.data;
    },
    enabled: !!(filters.contract_number || filters.uuid_contract),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
};

export const useAnniversaryPlanHistory = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: anniversaryPlanKeys.history(filters),
    queryFn: async () => {
      const response = await apiClient.get('anniversary-plan/history', { params: filters });
      return response.data;
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useSyncAnniversaryPlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post('anniversary-plan/sync');
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: anniversaryPlanKeys.all });
    },
    onError: (error) => {
      console.error('Error syncing anniversary plan:', error);
    },
  });
};
